export default "__VITE_ASSET__B3w9$JQx__"